/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';
import { action } from '@ember/object';
import { isBlank } from '@ember/utils';
import { task } from 'ember-concurrency';

const DEFAULT_MAX_ATTRIBUTES = 5;
const DEFAULT_MIN_ATTRIBUTES = 1;

type CollectionAttributesSelectModalArgs = {
  availableAttributes: string[];
  maxAttributes: number;
  minAttributes: number;
  selectedAttributes: string[];
  onClose: () => unknown;
  onSave: (attrs: string[]) => Promise<any>;
};

export default class CollectionAttributesSelectModal extends Component<CollectionAttributesSelectModalArgs> {
  @tracked selectedAttributes!: string[];
  @tracked search = '';
  @tracked hasError = false;

  get maxAttributes() {
    return this.args.maxAttributes ?? DEFAULT_MAX_ATTRIBUTES;
  }
  get minAttributes() {
    return this.args.minAttributes ?? DEFAULT_MIN_ATTRIBUTES;
  }
  get canAddColumn() {
    return this.selectedAttributes.length < this.maxAttributes;
  }
  get filteredAttributes() {
    let search = this.search.toLowerCase().trim();
    return isBlank(search)
      ? this.args.availableAttributes
      : this.args.availableAttributes.filter((attr) => attr.toLowerCase().includes(search));
  }

  saveAttributes = task({ drop: true }, async () => {
    try {
      await this.args.onSave(this.selectedAttributes);
      this.hasError = false;
    } catch {
      this.hasError = true;
    }
  });

  @action
  addColumn(column: string) {
    this.selectedAttributes.pushObject(column);
  }
  @action
  removeColumn(column: string) {
    if (this.selectedAttributes.length === this.minAttributes) {
      return;
    }
    this.selectedAttributes.removeObject(column);
  }

  constructor(owner: unknown, args: CollectionAttributesSelectModalArgs) {
    super(owner, args);

    this.selectedAttributes = this.args.selectedAttributes ? [...this.args.selectedAttributes] : [];
  }
}
